import { connect } from 'react-redux';

import VariantImage from '../components/VariantImage';

const mapStateToProps = state => {
  return {
    selectedVariant: state.selectedQuickShopVariant,
  };
};

export default connect(mapStateToProps)(VariantImage);
